import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '#environments';
import { PaginatedResult } from '#models';
import { AssetSummary } from '#models';
import { ProjectSummary } from '#models';

@Injectable({ providedIn: 'root' })
export class SearchService {
    private _http = inject(HttpClient);
    private _base = `${environment.apiBaseUrl}/v1/search`;

    searchAssets(query: string, page = 1, pageSize = 20): Observable<PaginatedResult<AssetSummary>> {
        return this._http.get<PaginatedResult<AssetSummary>>(`${this._base}/assets`, {
            params: { q: query, page: String(page), pageSize: String(pageSize) },
        });
    }

    searchProjects(query: string, page = 1, pageSize = 20): Observable<PaginatedResult<ProjectSummary>> {
        return this._http.get<PaginatedResult<ProjectSummary>>(`${this._base}/projects`, {
            params: { q: query, page: String(page), pageSize: String(pageSize) },
        });
    }
}
